  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.init = this.init.bind(this);
      
      // Get slide count
      const slides = this.querySelectorAll('.swiper-slide');
      this.slideCount = slides.length;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        
        // Check if Swiper is available
        if (typeof Swiper === 'undefined') {
          console.error('CartUpsell: Swiper is not loaded!');
          return;
        }
        
        try {
          this.swiper = new Swiper(this, {
            slidesPerView: "1",
            spaceBetween: 10,
            breakpoints: {
              500: {
                slidesPerView: this.slideCount > 1 ? "1.5" : "1"
              }
            },
            allowTouchMove: true,
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              type: "bullets",
            },
          });
        } catch (error) {
          console.error('CartUpsell: Error initializing swiper:', error);
        }
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
      window.removeEventListener('swiper-loaded', this.init);
    }
  }
  
  customElements.define('cart-upsell', CartUpsell);
